enum OrderStatusEnum {
  ACTIVE = "ACTIVE",
  REQUIRES_ACTION = "REQUIRES_ACTION",
  AWAITING_ACTION = "AWAITING_ACTION",
  COMPLETED = "COMPLETED",
  EXPIRED = "EXPIRED",
  AWAITING_PROCESSING = "AWAITING_PROCESSING",
  AWAITING_WEEKLY_INVOICING = "AWAITING_WEEKLY_INVOICING",
  AWAITING_MONTHLY_INVOICING = "AWAITING_MONTHLY_INVOICING",
  AWAITING_FINAL_AMOUNT = "AWAITING_FINAL_AMOUNT",
  PENDING_TRANSPORT = "PENDING_TRANSPORT",
  PENDING_FULL_LOAD_PRICE = "PENDING_FULL_LOAD_PRICE",
  PENDING_TRANSPORT_SELECTION = "PENDING_TRANSPORT_SELECTION",
  TRANSPORT_SELECTED = "TRANSPORT_SELECTED",
  PENDING_APPROVAL = "PENDING_APPROVAL",
  DELETED = "DELETED",
  AWAITING_FINAL_WEIGHT = "AWAITING_FINAL_WEIGHT",
  AWAITING_QUARTERLY_INVOICING = "AWAITING_QUARTERLY_INVOICING",
}

export default OrderStatusEnum;
